/** Account + security. Field labels: ui/common.js. */
const dictionary = {
  en: {
    title: "Settings",
    general: "General",
    changePassword: "Change Password",
    saveChanges: "Save changes",
    deleteAccount:
      "If you wish to delete or deactivate your account, send us a request in Help Center by filling out the form, or contacting us via email info@apexteam.ai. Please note that after deletion, all your data and information will be lost and cannot be recovered.",
    currentPassword: "Enter Current Password...",
    newPassword: "Enter New Password...",
    confirmNewPassword: "Confirm new password",
    wrongPassword: "Wrong password",
    toasts: {
      updatingDetails: "Updating details...",
      detailsSaved: "Setting details saved",
      detailsError: "Unable to save user data",
      updatingPassword: "Updating password...",
      passwordUpdated: "Password updated successfully",
      passwordMustBeSame: "Password must be same",
      invalidCurrentPassword: "Invalid current password",
      invalidValues: "Invalid values provided",
      fillAllFields: "Please fill all fields",
    },
  },
  de: {
    title: "Einstellungen",
    general: "Allgemein",
    changePassword: "Passwort ändern",
    saveChanges: "Änderungen speichern",
    deleteAccount:
      "Wenn Sie Ihr Konto löschen oder deaktivieren möchten, senden Sie uns im Hilfezentrum über das Formular eine Anfrage oder kontaktieren Sie uns per E-Mail unter info@apexteam.ai. Bitte beachten Sie, dass nach der Löschung alle Ihre Daten verloren gehen und nicht wiederhergestellt werden können.",
    currentPassword: "Aktuelles Passwort eingeben...",
    newPassword: "Neues Passwort eingeben...",
    confirmNewPassword: "Neues Passwort bestätigen",
    wrongPassword: "Falsches Passwort",
    toasts: {
      updatingDetails: "Daten werden aktualisiert...",
      detailsSaved: "Einstellungen gespeichert",
      detailsError: "Nutzerdaten konnten nicht gespeichert werden",
      updatingPassword: "Passwort wird aktualisiert...",
      passwordUpdated: "Passwort erfolgreich aktualisiert",
      passwordMustBeSame: "Das Passwort muss übereinstimmen",
      invalidCurrentPassword: "Ungültiges aktuelles Passwort",
      invalidValues: "Ungültige Werte angegeben",
      fillAllFields: "Bitte füllen Sie alle Felder aus",
    },
  },
  "fi": {
    "title": "Asetukset",
    "general": "Yleiset",
    "changePassword": "Vaihda salasana",
    "saveChanges": "Tallenna muutokset",
    "deleteAccount": "Jos haluat poistaa tilisi tai poistaa sen käytöstä, lähetä meille pyyntö täyttämällä lomake Ohjekeskuksessa tai ottamalla yhteyttä sähköpostitse osoitteeseen info@apexteam.ai. Huomaa, että poistamisen jälkeen kaikki tietosi häviävät, eikä niitä voi palauttaa.",
    "currentPassword": "Anna nykyinen salasana...",
    "newPassword": "Anna uusi salasana...",
    "confirmNewPassword": "Vahvista uusi salasana",
    "wrongPassword": "Väärä salasana",
    "toasts": {
      "updatingDetails": "Päivitetään tietoja...",
      "detailsSaved": "Asetukset tallennettu",
      "detailsError": "Käyttäjätietojen tallentaminen epäonnistui",
      "updatingPassword": "Päivitetään salasanaa...",
      "passwordUpdated": "Salasana päivitetty",
      "passwordMustBeSame": "Salasanojen on oltava samat",
      "invalidCurrentPassword": "Virheellinen nykyinen salasana",
      "invalidValues": "Annetut arvot ovat virheellisiä",
      "fillAllFields": "Täytä kaikki kentät"
    }
  }
};

export default dictionary;
